import { isValidObject } from "helpers/validation";

  const getUserDepartments = (user, departments) => {
    let userDepartments = [];
    if (user && user.department_ids && user.department_ids.length > 0) {
      if (departments && departments.length > 0) {
        for (let i = 0; i < user.department_ids.length; i++) {
          const foundDept = departments.filter((dept) => dept.id === user.department_ids[i]);
          if (foundDept && foundDept.length > 0) {
            userDepartments.push(foundDept[0]);
          }
        }
      }
    } else {
      if (user && user.owner_id && departments && departments.length > 0) {
        for (let j = 0; j < departments.length; j++) {
          if (departments[j].user_ids && departments[j].user_ids.length > 0) {
            const foundUser = departments[j].user_ids.filter((id) => id === user.owner_id);
            if (foundUser && foundUser.length > 0) {
              userDepartments.push(departments[j]);
            }
          }
        }
      }
    }
    return userDepartments;
  };

  const getUserSkills = (skill_ids, skills) => {
    let userSkills = [];
    const addedSkillIds = new Set(); // Track which skill IDs have already been added
    if (skill_ids && skill_ids.length > 0 && skills && skills.length > 0) {
      for (let i = 0; i < skill_ids.length; i++) {
        const skillId = skill_ids[i];
        // Skip if we've already added this skill ID
        if (addedSkillIds.has(skillId)) {
          continue;
        }
        const foundSkill = skills.filter((skill) => skill.id === skillId);
        if (foundSkill && foundSkill.length > 0) {
          userSkills.push(foundSkill[0]);
          addedSkillIds.add(skillId); // Mark this skill ID as added
        }
      }
    }
    return userSkills;
  }

  const getUserGroups = (user, channels) => {
    let userGroups = [];
    if (!channels || channels.length === 0) {
      return userGroups;
    }
    if (user.user && user.user.channel_ids) {
      for (let i = 0; i < user.user.channel_ids.length; i++) {
        const foundChannels = channels.filter((channel) => channel.id === user.user.channel_ids[i]);
        if (foundChannels && foundChannels.length > 0) {
          if( foundChannels[0].final_allow_manage == true ){
            userGroups.push(foundChannels[0]);
          }
        }
      }
    }
    return userGroups;
  }

  const getUserRoles = (uPriv, roles) => {
    let userRoles = [];
    const addedTagIds = new Set(); // Track which tag IDs have already been added
    if (!roles || roles.length === 0) {
      return userRoles;
    }

    var trueUserObj = uPriv;
    if (uPriv && uPriv.user && uPriv.user.tag_ids && uPriv.user.tag_ids.length > 0) {
      trueUserObj = uPriv.user;
    }

    if( isValidObject(trueUserObj)  == true && trueUserObj.tag_ids && trueUserObj.tag_ids.length > 0 ) {
      for (let i = 0; i < trueUserObj.tag_ids.length; i++) {
        const tagId = trueUserObj.tag_ids[i];
          // Skip if we've already added this tag ID
        if (addedTagIds.has(tagId)) {
          continue;
        }
        const foundRole = roles.filter((role) => role.id === tagId);
        if (foundRole && foundRole.length > 0) {
          userRoles.push(foundRole[0]);
          addedTagIds.add(tagId); // Mark this tag ID as added
        }
      }
    }
    
    return userRoles;
  }

  export default{
    getUserDepartments,
    getUserSkills,
    getUserGroups,
    getUserRoles,
  }